export default function TradingPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Trading</h1>
      <p className="text-muted-foreground">Order book and trading interface will be displayed here.</p>
    </div>
  );
}
